import { downloadBase64 } from "../ConnectriaTickets/utils";
import YetiDocuments from "../../services/YetiDocuments";

/**
 * downloadLightEdgeNotificationAttachment
 *
 * @param   {[string]} document_id
 * @returns {Object}
 */
export const downloadLightEdgeNotificationAttachment = (e, document_id) => {
    e.preventDefault();

    YetiDocuments.getDocument(document_id)
      .then((response) => {
        const filename = response.data.results["filename"];
        const mimeType = response.data.results["mime_type"];

        return YetiDocuments.downloadDocument(document_id).then((downloadResponse) => {
          downloadBase64(downloadResponse.data, filename, mimeType);
        });
      })
      .catch((error) => {
        console.error("Error processing the document:", error);
      });
};
